import React, { ChangeEvent, ReactNode } from 'react';
import { useTheme } from 'styled-components';
import type { IconComponent } from '../../themes/base/icons/types';
import { Container, Input, Span } from './check-box.styles';
import { Icon } from '../icon';

export interface CheckBoxProps extends Omit<
    React.InputHTMLAttributes<HTMLInputElement>,
    'onChange'
> {
    label?: string;
    name: string;
    disabled?: boolean;
    value?: string;
    icon?: IconComponent;
    onChange?: (value: boolean) => void;
    extra?: ReactNode;
    fillContainer?: boolean;
}

export function CheckBox({
    label,
    name,
    disabled,
    onChange = () => {},
    value,
    icon,
    checked,
    extra,
    fillContainer = true,
}: CheckBoxProps) {
    const onValueChange = (event: ChangeEvent<HTMLInputElement>) => {
        onChange(event.target.checked);
    };

    const theme = useTheme();

    return (
        <Container $fillContainer={fillContainer}>
            <Input
                type="checkbox"
                disabled={disabled}
                name={name}
                value={value}
                onChange={onValueChange}
                checked={checked}
                data-test-id={name}
            />
            {icon && (
                <Icon
                    icon={icon}
                    color={checked ? theme.inputActiveColor : theme.inputBorderColor}
                />
            )}
            <Span>{label}</Span> {extra}
        </Container>
    );
}
